<template>
    <div class="panel panel-default">
        <div class="panel-heading f -gutter-small -a-center">
            <editable-text :value.sync="producer.name"
                           class="expand"></editable-text>

            <div class="btn-group"
                 v-if="diff">
                <button class="btn btn-success btn-sm"
                        @click="save"
                        :class="valid ? '' : 'disabled'">
                    <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button class="btn btn-danger btn-sm"
                        @click="cancel">
                    <i class="glyphicon glyphicon-remove"></i>
                </button>
            </div>
        </div>

        <div class="panel-body">
            <div class="row">
                <div class="col-sm-3">
                    <h4>Téléphone <small>(fixe)</small></h4>
                    <editable-text :value.sync="producer.phone_land"></editable-text>

                    <h4>Téléphone <small>(mobile)</small></h4>
                    <editable-text :value.sync="producer.phone_cell"></editable-text>
                </div>
                <div class="col-sm-3">
                    <h4>Adresse</h4>
                    <editable-text :value.sync="producer.address"></editable-text>

                    <h4>Code postal</h4>
                    <editable-text :value.sync="producer.zip_code"></editable-text>
                </div>
                <div class="col-sm-3">
                    <h4>Bureau distributeur</h4>
                    <editable-text :value.sync="producer.bureau_distributeur">
                    </editable-text>

                    <h4>Référence Pro</h4>
                    <editable-text :value.sync="producer.siret"></editable-text>
                </div>
                <div class="col-sm-3">
                    <h4>Date entrée</h4>
                    <editable-date :value.sync="producer.date_enter"></editable-date>

                    <h4>Date sortie</h4>
                    <editable-date :value.sync="producer.date_exit"></editable-date>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import EditableText from '../editable/EditableText';
    import EditableDate from '../editable/EditableDate';
    import {asyncAction} from '../../utils';
    import {create, update} from '../../api/producers';
    import {manager as msgManager} from '../../messages';
    import equals from 'equals';

    export default {
        props: {
            producer: {
                required: true
            }
        },
        data() {
            return {
                savedProducer: null,
                loading: false
            };
        },
        components: {
            EditableDate,
            EditableText
        },
        computed: {
            valid() {
                return !!this.producer.name;
            },
            diff() {
                return !equals(this.savedProducer, this.producer);
            }
        },
        methods: {
            save: asyncAction('loading', async function () {
                if (this.valid && this.diff) {
                    if (this.producer.id) {
                        this.producer = await update(this.producer);
                    } else {
                        this.producer = await create(this.producer);
                    }

                    this.savedProducer = Object.assign({}, this.producer);

                    msgManager.push('Succès', `L'opération s'est bien déroulée.`, 'success');
                }
            }),
            cancel() {
                Object.assign(this.producer, this.savedProducer);
            }
        },
        ready() {
            this.savedProducer = Object.assign({}, this.producer);
        }
    };
</script>



// WEBPACK FOOTER //
// ProducerRow.vue?6bf4c513